<template>
    <dialogWrap v-model="isShow" :title="isEdit ? '编辑转账规则' : '新建转账规则'" width="420px">
        <form-text-box
            ref="transferRuleBox"
            :column="1"
            :dataList="transferList"
            :rules="transferRules"
            :formProps="formProps"
            :model="model"
        ></form-text-box>
        <template slot="footer">
            <div class="footer">
                <el-button size="small" @click="() => isShow = false">取消</el-button>
                <el-button :loading="loading" size="small" type="primary" @click="submit">{{ isEdit ? '保存' : '新建' }}</el-button>
            </div>
        </template>
    </dialogWrap>
</template>

<script>
import { merge, omit } from 'lodash'
import { config, timeTypeENUM } from './config'
import { getSuperviseAccountList, saveDivideRule, getDivideRuleDetail } from '@/api/domain/finance'
import { startDateState } from '@/pages/orders/personalOrder/config/selectOptions'

export default {
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    ruleId: {
      type: Number || String,
    },
    channelType: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    show(val) {
      if (val) {
        // 转出方：1，接收方：2
        this.getReceiverAndTransferAccountList([1, 2])

        if (this.isEdit) {
          this.getRuleDetail()
        } else {
          this.$nextTick(() => {
            this.setTimeList()
          })
        }
      } else {
        this.$refs.transferRuleBox?.getRefs().resetFields()
      }
      this.isShow = val
    },
    isShow(val) {
      this.$emit('change', val)
    },
  },
  data() {
    const { transferList, transferRules } = config.call(this)
    return {
      transferList,
      transferRules,
      loading: false,
      isShow: false,
      formProps: {
        labelWidth: '130px',
      },
      model: {
        ruleName: '',
        transferorId: '',
        receiverId: '',
        divideAmount: '',
        timeList: [],
        timeType: '',
      },
    }
  },
  methods: {
    submit() {
      this.$refs.transferRuleBox.getRefs().validate(async (validate) => {
        if (validate) {
          const internalParams = ['transferorName', 'receiverName']
          this.loading = true

          try {
            const { code, data } = await saveDivideRule({
              ...omit(this.model, this.isEdit ?
                internalParams
                :
              // 新建不需要提交ruleId
                [...internalParams, 'ruleId']),
              channelType: this.channelType,
            })

            this.loading = false

            if (code === 1) {
              if (data.result) {
                this.$message.success(`${this.isEdit ? '编辑' : '新建'}成功`)
              } else {
                this.$message.error(data.info)
              }
              this.isShow = false
              this.$emit('submitSucc')
            }
          } catch (error) {
            this.loading = false
          }
        }
      })
    },
    async getReceiverAndTransferAccountList(types) {
      const { code, data } = await getSuperviseAccountList({
        type: types,
        channelType: this.channelType,
        filterDisabled: !this.isEdit,
      })
      if (code === 1) {
        this.$refs.transferRuleBox.setItemData({ elConfigKey: 'list', key: 'transferorId', data: data.transferorList })
        this.$refs.transferRuleBox.setItemData({ elConfigKey: 'list', key: 'receiverId', data: data.receiverList })
      }
    },
    async getRuleDetail() {
      const { code, data } = await getDivideRuleDetail({
        ruleId: this.ruleId,
      })

      if (code === 1) {
        this.model = merge(this.model, data)
        this.model.timeList = Array.from(this.model.timeList)
        this.setTimeList(data.timeType)
      }
    },
    setTimeList(type) {
      if (type === timeTypeENUM.WEEK || type === timeTypeENUM.MONTH) {
        const list = type === timeTypeENUM.WEEK ? this.dictParseList(startDateState) : Array.from({ length: 31 }, (_, index) => ({ label: `${index + 1}号`, value: index + 1 }))
        this.$refs.transferRuleBox.setItemData({
          elConfigKey: 'isShow',
          key: 'timeList',
          data: true,
        })

        this.$refs.transferRuleBox.setItemData({
          elConfigKey: 'list',
          key: 'timeList',
          data: list,
        })
        this.transferRules.timeList[0].required = true
      } else {
        this.$refs.transferRuleBox.setItemData({
          elConfigKey: 'isShow',
          key: 'timeList',
          data: false,
        })
        this.transferRules.timeList[0].required = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
    text-align: center;
}
</style>
